const images = {
    auth: require('~/assets/images/auth.png'),
    bgAuth: require('~/assets/images/bg-auth.jpg'),
    logo: require('~/assets/images/logo.png'),
};
export default images;
